var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-2"},[_c('TabsVue',{attrs:{"tabs":_vm.tabs,"theme":`material`}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }